export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8631.f017bf7e.jpg";